import styled, { css } from "styled-components";
import { useDesignTokens } from "@boi/react-design-tokens";

import { type Layout } from "./Table.types";

type TableProps = {
  $layout?: Layout;
};

export const Table = styled.table<TableProps>`
  ${({ $layout }) => {
    const { tokens } = useDesignTokens();
    const { table } = tokens;

    return [
      css`
        border-collapse: collapse;
        border-bottom-width: ${table.stroke.bottom.width};
        border-bottom-style: ${table.stroke.bottom.style};
        border-bottom-color: ${table.stroke.bottom.color};

        & thead {
          background: ${table.head.backgroundColor};
          border-bottom-width: ${table.head.stroke.bottom.width};
          border-bottom-style: ${table.head.stroke.bottom.style};
          border-bottom-color: ${table.head.stroke.bottom.color};

          & tr {
            & th {
              text-wrap: balance;
              vertical-align: bottom;
              overflow-wrap: anywhere;
              padding-top: ${table.head.cell.padding.top};
              padding-left: ${table.head.cell.padding.left.base};
              padding-right: ${table.head.cell.padding.right.base};
              padding-bottom: ${table.head.cell.padding.bottom};
            }

            & > :first-child {
              padding-left: ${table.head.cell.padding.left.first};
            }

            & > :last-child {
              padding-right: ${table.head.cell.padding.right.last};
            }
          }
        }

        & tbody {
          & tr {
            & th,
            & td {
              text-wrap: balance;
              vertical-align: top;
              overflow-wrap: anywhere;
              padding-top: ${table.body.cell.padding.top};
              padding-left: ${table.body.cell.padding.left.base};
              padding-right: ${table.body.cell.padding.right.base};
              padding-bottom: ${table.body.cell.padding.bottom};
            }

            & > :first-child {
              padding-left: ${table.body.cell.padding.left.first};
            }

            & > :last-child {
              padding-right: ${table.body.cell.padding.right.last};
            }

            &:nth-of-type(odd) {
              background: ${table.body.row.backgroundColor.odd};
            }

            &:nth-of-type(even) {
              background: ${table.body.row.backgroundColor.even};
            }
          }
        }
      `,
      $layout &&
        css`
          table-layout: ${$layout};
        `,
    ];
  }}
`;
